module.exports = __webpack_public_path__ + "img/mdsicon.6d26db9b.png";